import type { IOption } from 'common/interfaces/IOption'

export const APPOINTMENT_COLOR_OPTIONS: IOption[] = [
  { code: 'status', name: 'Status' },
  { code: 'category', name: 'Category' },
]
